import { useEffect } from "react";

// arrays
import { Headshots } from "../../arrays/MediaLists";


function Media() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="wrapper media">
            <h2>Media</h2>
            <ul className="gallery">
                {
                    Headshots.map((headshot, i) => {
                        return (
                            <li key={i}>
                                {headshot.image}
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
};

export default Media;